import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Title } from "../../../../../stories/Title/Title";
import {
  LicenseTypes,
  Operation,
  PageFor,
  TableHeaders,
} from "../../../../../utils/Enum.types";
import { Button } from "../../../../../stories/Button/Button";
import { useEffect, useMemo, useState } from "react";
import FileAttach from "../../../../../images/BrowseFiles.svg";
import DownArrow from "../../../../../images/DownArrow.svg";
import TotalStudents from "../../../../../images/TotalMale.svg";
import ReadyToImport from "../../../../../images/Present.svg";
import ContainsError from "../../../../../images/Absent.svg";
import ExcelJS from "exceljs";
import Info from "../../../../../images/Information.svg";

import Close from "../../../../../images/Close.svg";
import ReactModal from "react-modal";
import { LoadingStyles } from "../../../../../styles/ModalStyles";

import { useLazyQuery, useMutation } from "@apollo/client";
import {
  EMPTY_STRING,
  emptyMessage,
  ROWS_PER_PAGE,
} from "../../../../../utils/constants";
import { getDownloadUrl } from "../../../../../utils/DownloadFile";

import useUrlParams from "../../../../../customHooks/useUrlParams";
import * as XLSX from "xlsx";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import LoadingModal from "../../../../pages/LoadingModal";
import MessageModal from "../../../../../customComponents/MessageModal";
import ExcelLoading from "../../../../pages/ExcelLoading";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import { CustomTooltip } from "../../../../../styles/TooltipStyles";
import { ExportSubsidiaryTemplate } from "../items/queries/mutations";
import {
  AddSubsidiaryResult,
  AddSubsidiaryVar,
  AtsSubsidiaryOrderField,
} from "./queries/types";
import { AddSubsidiary } from "./queries/mutations";
import { GetSubsidiaries } from "./queries/queries";
import useLabels from "../../../../../customHooks/useLabels";
import {
  removeCompleteSpace,
  removeMoreSpace,
} from "../../../../../utils/UtilFunctions";
import Navbar from "../../../../common/layout/Navbar";
import { useNavigate } from "react-router-dom";

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  pageType: PageFor;
  NavType: LicenseTypes;
}

const ImportSubsidiary = ({ setModalFlag, NavType, pageType }: Props) => {
  const { user_details } = useLoggedInUserDetails();
  const [records, setRecords] = useState<any[]>([]);
  const [message, setMessage] = useState(emptyMessage);
  const { customer_id, company_id } = useUrlParams();
  const [importModal, setImportModal] = useState(false);
  const [successCount, setSuccessCount] = useState(0);
  const [errorCount, setErrorCount] = useState(0);

  const navigate = useNavigate();

  const [expanded, setExpanded] = useState(false);

  const { subsidiaryLabel, itemLabel } = useLabels();
  const [AddSubDetails, { loading: AddSubsidiaryLoading }] = useMutation<
    AddSubsidiaryResult,
    AddSubsidiaryVar
  >(AddSubsidiary, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });
  const [ExportItems, { loading: AddItemLoading }] = useLazyQuery(
    ExportSubsidiaryTemplate,
    {
      onError: (e) => {
        setMessage({
          flag: true,
          message: e.message,
          operation: Operation.NONE,
        });
      },
    }
  );
  const displayFileName = (): void => {
    const inputElement = document.getElementById("input") as HTMLInputElement;
    const fileName = inputElement.value;
    const fileLabel = document.getElementById("file-name") as HTMLSpanElement;
    fileLabel.innerHTML = fileName.split("\\").pop()!;
  };
  const handleExport = async () => {
    try {
      if (customer_id) {
        const { data, errors } = await ExportItems({
          variables: {
            customerID: customer_id,
          },
        });

        if (data && data.ExportSubsidiaryTemplate) {
          const res = await getDownloadUrl(data.ExportSubsidiaryTemplate, true);
          if (res) {
            setMessage({
              flag: true,
              message: "Downloading...",
              operation: Operation.CREATE,
            });
          }
        } else {
          setMessage({
            flag: true,
            message: "Failed downloading file",
            operation: Operation.NONE,
          });
        }

        if (errors && errors.length > 0) {
          setMessage({
            flag: true,
            message: errors[0].message,
            operation: Operation.NONE,
          });
        }
      }
    } catch (err) {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE,
      });
    }
  };
  const totalRecords = useMemo(() => {
    return records.filter((record) => !record.errors).length;
  }, [records]);

  const downloadExcelContainsError = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet1 = workbook.addWorksheet("ErrorData");
    worksheet1.views = [{ state: "frozen", xSplit: 1, ySplit: 1 }];
    if (records.length === 0) {
      console.warn("No data available to create the Excel file.");
      return;
    }

    const errorColumns = ["errors"];
    const headers = Object.keys(records[0]).filter(
      (header) =>
        !["isChecked", "isValidated", "isValidatedAndError", "id"].includes(
          header
        )
    );

    errorColumns.forEach((col) => {
      if (!headers.includes(col)) {
        headers.push(col);
      }
    });
    worksheet1.columns = headers.map((header) => ({
      header,
      key: header,
      width: 20,
    }));

    const headerRow = worksheet1.getRow(1);
    headerRow.height = 25;
    headerRow.font = { name: "Arial", size: 12, bold: true };
    headerRow.alignment = { vertical: "middle", horizontal: "center" };
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFE0B2" },
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    records
      .filter((record) => record?.errors)
      .forEach((entry, rowIndex) => {
        const row = worksheet1.getRow(rowIndex + 2);
        headers.forEach((header, colIndex) => {
          const cell = row.getCell(colIndex + 1);
          cell.value = entry[header];
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
        });
      });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "StudentInfo.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };
  const handleAddItems = async () => {
    setSuccessCount(0);
    setErrorCount(0);
    setImportModal(true);

    for (const record of records.filter((record) => !record.errors)) {
      try {
        await AddSubDetails({
          variables: {
            user_details,
            customerID: customer_id!,
            companyID: company_id!,

            input: {
              name: removeMoreSpace(
                record[`${removeCompleteSpace(subsidiaryLabel)}`]
              ),
              address: removeMoreSpace(record.Address),
              place: removeMoreSpace(record.Place),
              state: removeMoreSpace(record.State),
              pin: removeMoreSpace(record.Pin),
              country: removeMoreSpace(record.Country),
              contactPerson: removeMoreSpace(record.ContactPerson),
              contactPersonDesign: removeMoreSpace(record.ContactPersonDesign),
              contactPersonEmail: removeMoreSpace(record.ContactPersonEmail),
              contactPersonMobile: removeMoreSpace(record.ContactPersonMobile),
              email: removeMoreSpace(record.Email),
              mobile: removeMoreSpace(record.Mobile),
              url: removeMoreSpace(record.URL),
              logoFilename: record.LogoFilename,
              isActive: record.IsActive,
              panNo: removeMoreSpace(record.PanNo),
              gstNo: removeMoreSpace(record.GstNo),
              tanNo: removeMoreSpace(record.TanNo),
              vatNo: removeMoreSpace(record.VatNo),
              oth1No: removeMoreSpace(record.Oth1No),
              oth2No: removeMoreSpace(record.Oth2No),
              enableGst: record.EnableGst,
              enableTds: record.EnableTds,
              enableTcs: record.EnableTcs,
              latitude: record.Latitude,
              longitude: record.Longitude,
              timeZone: removeMoreSpace(record.TimeZone),
              icon: record.icon,
            },
          },
          refetchQueries: [
            {
              query: GetSubsidiaries,
              variables: {
                after: null,
                customerID: customer_id,
                companyID: company_id,
                empID: user_details.id,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsSubsidiaryOrderField.NAME,
                },

                name: EMPTY_STRING,
              },
            },
          ],
        }).then(({ data }) => {
          if (data) {
            setSuccessCount((prev) => prev + 1);
          }
        });
      } catch (error) {
        console.error(error);
        setErrorCount((prev) => prev + 1);
      }
    }
  };

  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      setModalFlag(false);
    }
    setMessage({
      message: "",
      flag: false,
      operation: Operation.NONE,
    });
  };
  const item_schema = {
    [`${removeCompleteSpace(subsidiaryLabel)}`]: {
      Headers: "Name",
      key: "Name",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Address: {
      Headers: "Address",
      key: "Address",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Place: {
      Headers: "Place",
      key: "Place",
      width: 50,
      required: false,
      use_in_sheet: true,
    },

    State: {
      Headers: "State",
      key: "State",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Pin: {
      Headers: "Pin",
      key: "Pin",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Country: {
      Headers: "Country",
      key: "Country",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    ContactPerson: {
      Headers: "ContactPerson",
      key: "ContactPerson",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    ContactPersonDesign: {
      Headers: "ContactPersonDesign",
      key: "ContactPersonDesign",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    ContactPersonEmail: {
      Headers: "ContactPersonEmail",
      key: "ContactPersonEmail",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    ContactPersonMobile: {
      Headers: "ContactPersonMobile",
      key: "ContactPersonMobile",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Email: {
      Headers: "Email",
      key: "Email",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Mobile: {
      Headers: "Mobile",
      key: "Mobile",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    URL: {
      Headers: "URL",
      key: "URL",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    LogoFilename: {
      Headers: "LogoFilename",
      key: "LogoFilename",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    IsActive: {
      Headers: "IsActive",
      key: "IsActive",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    PanNo: {
      Headers: "PanNo",
      key: "PanNo",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    GstNo: {
      Headers: "GstNo",
      key: "GstNo",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    TanNo: {
      Headers: "TanNo",
      key: "TanNo",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    VatNo: {
      Headers: "VatNo",
      key: "VatNo",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Oth1No: {
      Headers: "Oth1No",
      key: "Oth1No",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Oth2No: {
      Headers: "Oth2No",
      key: "Oth2No",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    EnableGst: {
      Headers: "EnableGst",
      key: "EnableGst",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    EnableTds: {
      Headers: "EnableTds",
      key: "EnableTds",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    EnableTcs: {
      Headers: "EnableTcs",
      key: "EnableTcs",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Latitude: {
      Headers: "Latitude",
      key: "Latitude",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Longitude: {
      Headers: "Longitude",
      key: "Longitude",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    TimeZone: {
      Headers: "TimeZone",
      key: "TimeZone",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
  };

  const schemaKeys = Object.keys(item_schema);

  const processExcel = (data: any) => {
    const workbook = XLSX.read(data, { type: "binary" });
    const firstSheet = workbook.SheetNames[0];
    const records = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheet]);
    records.forEach((record: any) => {
      let errors: any = [];

      Object.keys(item_schema).forEach((key) => {
        // @ts-ignore
        let keySchema = item_schema[key];
        let keyValue = record[key];

        if (
          keySchema?.required &&
          (keyValue === null || keyValue === undefined)
        ) {
          let errorObj = {
            column: key,
            error: "Required",
          };
          errors.push(errorObj);
        }
      });

      if (errors.length > 0) {
        record.errors = errors;
      }
    });

    return records;
  };

  useEffect(() => {
    const input = document.getElementById("input") as HTMLInputElement;
    if (input) {
      input.addEventListener("change", () => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const res = processExcel(reader.result);
          setRecords(
            res.map((f: any, index: number) => {
              return {
                ...f,
                id: index + 1,
                isChecked: false,
                isValidated: false,
                isValidatedAndError: false,
              };
            })
          );
        };
        reader.readAsBinaryString(input.files![0]);
      });
    }
  });

  return (
    <>
      {pageType === PageFor.GENERAL ? (
        <>
          <Navbar NavType={NavType} />
          <Title>Import {subsidiaryLabel}</Title>
        </>
      ) : null}
      <div
        className={`import-excel-data${
          pageType === PageFor.GENERAL ? "" : "__modal"
        }`}
      >
        {pageType === PageFor.MODAL && (
          <div className="import-excel-data--title">
            <Title>Import {subsidiaryLabel}</Title>
            <img src={Close} alt="" onClick={() => setModalFlag(false)} />
          </div>
        )}
        <div className="row g-0 import-excel-data__blocks">
          <div className="col-6">
            <div className="import-excel-data__file-upload">
              <div className="import-excel-data__file-upload--file-name">
                <span id="file-name"></span>
              </div>
              <div className="import-excel-data__file-upload--browse">
                <label htmlFor="input">
                  <img src={FileAttach} alt="/" /> Choose Excel File
                </label>
                <input
                  id="input"
                  type="file"
                  name="file"
                  onChange={() => displayFileName()}
                  className="import-excel-data__file-upload--input"
                />
              </div>
            </div>
          </div>

          <div className="col import-excel-data__blocks--cards">
            <b>
              <img src={TotalStudents} alt="/" />
              Total {itemLabel}
            </b>
            <span className="import-excel-data__blocks--cards--total-students">
              {records.length}
            </span>
          </div>
          <div
            className="col import-excel-data__blocks--cards"
            // onClick={() => setExpanded(!expanded)}
          >
            <b>
              <img src={ReadyToImport} alt="/" />
              Ready to Import
            </b>
            <span className="import-excel-data__blocks--cards--ready-to-import">
              {records.filter((record) => !record.errors).length}
            </span>
          </div>
          <div
            className="col import-excel-data__blocks--cards"
            onClick={() => setExpanded(!expanded)}
          >
            <b>
              <img src={ContainsError} alt="/" />
              Contains Error
            </b>
            <span className="import-excel-data__blocks--cards--contains-error">
              {records.filter((record) => record?.errors).length}
            </span>
          </div>
        </div>
        <div className="import-excel-data__datablock">
          {records.length > 0 ? (
            <>
              <div
                className="import-excel-data__datablock--title"
                onClick={() => setExpanded(!expanded)}
              >
                <div className="import-excel-data__datablock--records-count">
                  <span>
                    {records.filter((record) => !record.errors).length}
                  </span>
                  <b> Records Found to Import</b>
                </div>
                <img src={DownArrow} alt="/" />
              </div>
              <div className="import-excel-data__datablock--tableblock">
                <TableContainer className="import-excel-data__datablock--table">
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell id="td-center">
                          {TableHeaders.SLNO}
                        </TableCell>
                        {schemaKeys
                          .filter((key) =>
                            records.some((record) => key in record)
                          )
                          .map((key, index) => (
                            <TableCell key={index}>{key}</TableCell>
                          ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {records
                        .filter((record) => !record?.errors)
                        .map((record, index) => (
                          <TableRow key={index}>
                            <TableCell id="td-center">{index + 1}</TableCell>
                            {schemaKeys
                              .filter((key) => key in record)
                              .map((key, colIndex) => (
                                <TableCell key={colIndex}>
                                  {record[key]}
                                </TableCell>
                              ))}
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
              <div
                className="import-excel-data__datablock--title"
                onClick={() => setExpanded(!expanded)}
              >
                <div className="import-excel-data__datablock--errors-count">
                  <span>{records.filter((d) => d?.errors).length}</span>
                  <b>Records Which Contains error(s)</b>
                </div>
                <img src={DownArrow} alt="/" />
              </div>
              {expanded && (
                <div className="import-excel-data__datablock--tableblock">
                  <TableContainer className="import-excel-data__datablock--table">
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell id="td-center">
                            {TableHeaders.SLNO}
                          </TableCell>
                          {schemaKeys
                            .filter((key) =>
                              records.some((record) => key in record)
                            )
                            .map((key, index) => (
                              <TableCell key={index}>{key}</TableCell>
                            ))}
                          <TableCell id="td-center">Error Details</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {records
                          .filter((record) => record?.errors)
                          .map((record, index) => {
                            return (
                              <TableRow key={index}>
                                <TableCell id="td-center">
                                  {index + 1}
                                </TableCell>
                                {schemaKeys
                                  .filter((key) => key in record)
                                  .map((key, colIndex) => (
                                    <TableCell key={colIndex}>
                                      {record[key]}
                                    </TableCell>
                                  ))}

                                <TableCell className="import-excel-data__datablock--error">
                                  <CustomTooltip
                                    title={
                                      <ul>
                                        {record?.errors
                                          ? record?.errors?.map(
                                              (error: any, index: number) => {
                                                return (
                                                  <li key={index}>
                                                    {index + 1})&nbsp;
                                                    {typeof error === "string"
                                                      ? error
                                                      : "Error message = " +
                                                        error.error +
                                                        ", column = " +
                                                        error.column}
                                                  </li>
                                                );
                                              }
                                            )
                                          : null}
                                      </ul>
                                    }
                                    arrow
                                    placement="bottom-start"
                                  >
                                    <div className="import-excel-data__datablock--tableblock--error-message">
                                      <span>Errors</span>
                                      <img src={Info} alt="/" />
                                    </div>
                                  </CustomTooltip>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}
            </>
          ) : null}
        </div>
        <div className="row g-0">
          <div className="col">
            <Button
              onClick={() => {
                setImportModal(true);
                handleAddItems();
              }}
              disabled={!records.length ? true : false}
              mode="excel"
            >
              Import {subsidiaryLabel}
            </Button>

            <Button onClick={downloadExcelContainsError} mode="excel">
              Export error Data
            </Button>
            <Button
              mode={pageType === PageFor.GENERAL ? "back" : "cancel"}
              onClick={() => {
                if (pageType === PageFor.MODAL) {
                  setModalFlag(false);
                } else {
                  navigate(-1);
                }
              }}
            />
          </div>
          <div className="col import-excel-data__button">
            <Button mode="excel" onClick={handleExport}>
              Generate Template XLS File
            </Button>
          </div>
        </div>
      </div>

      <ReactModal
        shouldCloseOnOverlayClick={true}
        isOpen={importModal}
        style={LoadingStyles}
        ariaHideApp={false}
        onRequestClose={() => setImportModal(!importModal)}
      >
        <ExcelLoading
          total={totalRecords}
          success={successCount}
          errors={errorCount}
          loading={AddSubsidiaryLoading}
          setModalFlag={setImportModal}
        />
      </ReactModal>
      <LoadingModal flag={AddItemLoading} />
      <MessageModal
        modalFlag={message.flag!}
        value={message.message!}
        handleClose={handleClose}
        operation={message.operation!}
      />
    </>
  );
};

export default ImportSubsidiary;
